<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-licencing_nr_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >{{ channelName }}
    </template>

    <template slot="body">
      
        <div class="form-group">
          <div class="dt-modal--subtitle">
            {{ selectedContractDetails.contract.royalty_account_name }} -
            {{ selectedContractDetails.contract.contract_name }}
          </div>
          <TextField
            :id="'royalty_rate'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyLicencingNr.ro.royalty_rate"
            :placeholder="$t('royalty_rate')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'ppu_adjustment'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyLicencingNr.ro.ppu_adjustment"
            :placeholder="$t('adjustment')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'deduction1'"
            class="m1"
            v-bind="textFieldConfig"
            :value="royaltyLicencingNr.ro.deduction1"
            :placeholder="'Deduction 1'"
            @valuechanged="onTextFieldValueChange"
          />

          <Dropdown
            :id="'territory'"
            class="m2"
            :options="territoryTV"
            deselect
            :selected="
              territoryTV.find(
                e => e.value == royaltyLicencingNr.ro.territory_id
              )
            "
            :placeholder="$t('territory')"
            box
            @selectedChange="e => onDropdownChange('territory_id', e)"
          ></Dropdown>

          <Dropdown
            :id="'usage_type'"
            class="m2"
            :options="usageTypesTV"
            deselect
            :selected="
              usageTypesTV.find(
                e => e.value == royaltyLicencingNr.ro.usage_type
              )
            "
            :placeholder="$t('usage_type')"
            box
            @selectedChange="e => onDropdownChange('usage_type', e)"
          ></Dropdown>

          <Dropdown
            :id="'account'"
            class="m2"
            deselect
            :options="accountTV"
            :selected="
              accountTV.find(e => e.value == royaltyLicencingNr.ro.account_id)
            "
            :placeholder="$t('account')"
            box
            @selectedChange="e => onDropdownChange('account_id', e)"
          ></Dropdown>

          <!-- v-if="channel == 'performance'" -->
          <Dropdown
            :id="'bundle_track'"
            class="m2"
            deselect
            :options="digitalFormatTypesTV"
            :selected="
              digitalFormatTypesTV.find(
                e => e.value == royaltyLicencingNr.ro.format_type
              )
            "
            :placeholder="$t('bundle_track')"
            box
            @selectedChange="e => onDropdownChange('format_type', e)"
          ></Dropdown>

          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'turnover_scale'"
                :id="'turnover_scale'"
                :checked="royaltyLicencingNr.ro.turnover_scale == 1"
                @change="e => onCheckboxChange('turnover_scale', e)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">Turnover Scale</div>
          </div>
        </div>
     
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { ContractsService } from "../../services/contracts.service";
import { async } from "rxjs/internal/scheduler/async";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";

export default {
  components: {
    Modal,
    InputField
  },
  props: ["selectedContractDetails"],
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      },

      royaltyLicencingNr: this.get_royaltyLicencingNr(),
      saveRoyaltyOptionFlag: false
    };
  },
  mounted: async function() {
    if (this.isEditMode) {
      if (this.channel == "performance") {
        const res = await ContractsService.performanceLicencingNrForm({
          contract_id: this.contract_id,
          royalty_option_id: this.royalty_option_id
        });
        this.royaltyLicencingNr = res.data;
      } else if (this.channel == "thirdparty") {
        const res = await ContractsService.thirdpartyLicencingNrForm({
          contract_id: this.contract_id,
          royalty_option_id: this.royalty_option_id
        });
        this.royaltyLicencingNr = res.data;
      } else {
        return this.royaltyLicencingNr;
      }
    } else if (this.isAddMode) {
      if (this.channel == "performance") {
        const addRes = await ContractsService.licencingNrAddForm({
          contract_id: this.contract_id
        });
        // console.log("show sequence no ", addRes.data.sequence_no);
        this.royaltyLicencingNr = {
          ...addRes.data,
          ...this.royaltyLicencingNr
        };
      } else if (this.channel == "thirdparty") {
        const addRes = await ContractsService.addThirdpartyForm({
          contract_id: this.contract_id
        });
        this.royaltyLicencingNr = {
          ...addRes.data,
          ...this.royaltyLicencingNr
        };
      }
    }
  },
  computed: {
    contract_id: function() {
      return this.$route.params.contract_id;
    },

    royalty_option_id: function() {
      return this.$route.query.royalty_option_id;
    },
    channel: function() {
      return this.$route.query.channel;
    },
    channelName: function() {
      return this.channel == "performance"
        ? `${this.$t("add_performance")}`
        : `${this.$t("add_thirdparty")}`;
    },
    mode: function() {
      return this.$route.query.mode;
    },
    isEditMode: function() {
      return this.mode == "edit";
    },
    isAddMode: function() {
      return this.mode == "add";
    },
    title: function() {
      if (this.isEditMode) {
        return "Edit";
      } else if (this.isAddMode) {
        return "Add";
      } else {
        return "";
      }
    },
    territoryTV: function() {
      return createTV(this.royaltyLicencingNr.territories, "label", "value");
    },
    accountTV: function() {
      return createTV(this.royaltyLicencingNr.accounts, "label", "value");
    },
    usageTypesTV: function() {
      return createTV(this.royaltyLicencingNr.usage_types, "label", "value");
    },
    digitalFormatTypesTV: function() {
      return createTV(
        this.royaltyLicencingNr.digital_format_types,
        "label",
        "value"
      );
    },
    saveRoyaltyOption: function() {
      return {
        royalty_rate: this.royaltyLicencingNr?.ro?.royalty_rate,
        ppu_adjustment: this.royaltyLicencingNr?.ro?.ppu_adjustment,
        deduction1: this.royaltyLicencingNr?.ro?.deduction1,
        territory_id: this.royaltyLicencingNr?.ro?.territory_id,
        usage_type: this.royaltyLicencingNr?.ro?.usage_type,
        account_id: this.royaltyLicencingNr?.ro?.account_id,
        format_type: this.royaltyLicencingNr?.ro?.format_type,
        turnover_scale: this.royaltyLicencingNr?.ro?.turnover_scale,
        contract_id: this.contract_id,
        sequence_no: this.royaltyLicencingNr?.sequence_no,
        royalty_option_id: this.royalty_option_id
      };
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },

    onTextFieldValueChange: function(name, value) {
      this.royaltyLicencingNr.ro[name] = value;
    },

    onDropdownChange(name, value) {
      this.royaltyLicencingNr.ro[name] = value.value;
    },
    onCheckboxChange: function(name, event) {
      const value = event.target.checked ? "1" : "0";
      this.royaltyLicencingNr.ro[name] = value;
    },

    onOkClick: async function() {
      if (this.isAddMode) {
        if (this.channel == "performance") {
          const res = await ContractsService.savePerformanceLicencingNr(
            this.saveRoyaltyOption
          );
          this.$emit("added", {
            ...res.data,
            channel: this.channel
          });
        } else if (this.channel == "thirdparty") {
          const res = await ContractsService.saveThirdpartyLicencingNr(
            this.saveRoyaltyOption
          );
          this.$emit("added", {
            ...res.data,
            channel: this.channel
          });
        }
      } else if (this.isEditMode) {
        this.$emit("edited", {
          channel: this.channel,
          item: this.royaltyLicencingNr?.ro,
          saveRoyaltyOptionFlag: true,
          saveRoyaltyOption: this.saveRoyaltyOption
        });
      }
    },

    get_royaltyLicencingNr: function() {
      return {
        ro: {
          royalty_rate: null,
          ppu_adjustment: null,
          deduction1: null,
          territory_id: null,
          usage_type: "",
          account_id: null,
          format_type: null,
          turnover_scale: null
        }
      };
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-licencing_nr_form {
  .body-container {
    max-height: 460px;
    padding-right: 15px;
    overflow: hidden;
    overflow-y: auto;
    .dt-modal--subtitle {
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .dt-checkbox-control {
    align-items: center;
    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }
}
</style>
